import type { FC } from 'react';

import { useAppSelector } from '../../../store/react_redux_typed';

import styles from './storage_name.module.css';

type Props = { storageId: string };

export const StorageName: FC<Props> = ({ storageId }) => {
  const storage = useAppSelector((state) => state.entities.storages[storageId]);
  if (!storage) {
    return null;
  }
  return <div className={styles.root}>{storage.name}</div>;
};
